import { getMinMaxParams } from "./getMinMaxParams";

export const getSceneHeight = () => {
  let params = getMinMaxParams(window['scene'])
  return Math.abs(params.max.y - params.min.y);
}
